import { render, staticRenderFns } from "./WheelReportPanel.vue?vue&type=template&id=3f31fd22&"
import script from "./WheelReportPanel.vue?vue&type=script&lang=js&"
export * from "./WheelReportPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports